<template>
  <div>
    <div class="dashboard-title">{{ pageTitle }}</div>
    <hr />
    <div class="transaction-info">
      <div
        class="balance-card w-100 w-md-50"
        :class="convertType == 'USDToGCoin' ? 'yellow-balance' : 'blue-balance'"
      >
        <p class="balance-title">{{ balanceTitle }}</p>
        <div class="balance-area">
          <span class="currency" v-if="convertType == 'USDToGCoins'">USD</span>
          <span class="balance">{{ numberWithCommas(balance) }}</span>
        </div>
      </div>
      <div class="recharge-steps">
        <div class="login-form">
          <p>{{ howMany }}</p>
          <div
            class="alert alert-danger w-100 py-1"
            role="alert"
            v-if="showErr"
          >
            {{ err }}
          </div>
          <div class="cash-out-amount">
            <input required type="number" id="amount" v-model="amount" />
          </div>
          <span>{{ equivalentText }}</span>
          <div class="btn btn-gold btn-block text-white" @click="cashOut">
            {{ convertBtn }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      convertType: "",
      pageTitle: "",
      balanceTitle: "",
      balance: "",
      howMany: "",
      amount: null,
      equivalentText: "",
      equivalence: 0,
      convertBtn: "",
      showErr: false,
      err: "",
    };
  },
  mounted() {
    this.iniPage();
    this.getData();
  },
  methods: {
    iniPage() {
      const currentPath = this.$router.history.current.path.substring(1);
      if (currentPath.endsWith("USDToGCoin-convert")) {
        this.convertType = "USDToGCoin";
        this.pageTitle = this.$t("dashboard.convert.USDToGCoin.title");
        this.balanceTitle = this.$t("dashboard.convert.USDToGCoin.balance");
        this.howMany = this.$t("dashboard.convert.USDToGCoin.howMany");
        this.equivalentText = this.$t(
          "dashboard.convert.USDToGCoin.equivalence",
          { equivalence: this.numberWithCommas(this.equivalence) }
        );
        this.convertBtn = this.$t("dashboard.convert.USDToGCoin.convert");
      } else if (currentPath.endsWith("GCoinToUSD-convert")) {
        this.convertType = "GCoinToUSD";
        this.pageTitle = this.$t("dashboard.convert.GCoinToUSD.title");
        this.balanceTitle = this.$t("dashboard.convert.GCoinToUSD.balance");
        this.howMany = this.$t("dashboard.convert.GCoinToUSD.howMany");
        this.equivalentText = this.$t(
          "dashboard.convert.GCoinToUSD.equivalence",
          { equivalence: this.numberWithCommas(this.equivalence) }
        );
        this.convertBtn = this.$t("dashboard.convert.GCoinToUSD.convert");
      }
    },
    getData() {
      // 调用API获取余额数据
      this.balance = 125631;
    },
    cashOut() {
      if (!this.amount) {
        this.err = this.$t("dashboard.withdraw.err");
        this.showErr = true;
        return;
      }
      alert(this.amount);
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  watch: {
    amount: function () {
      if (this.amount) this.showErr = false;
    },
    "$i18n.locale": function () {
      this.iniPage();
    },
  },
};
</script>

<style scoped>
hr {
    margin-bottom: 1rem;
}
.transaction-info {
  align-items: center;
  justify-content: center;
  .balance-card {
    height: fit-content;
  }
}
.recharge-steps {
  margin-top: 0;
  .login-form {
    box-shadow: 0px 4.4px 22px 0px #0000000d;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    padding: 2rem;
    width: 100%;
    max-width: 436px;
    margin: 0 auto;
    p {
      text-align: center;
      width: 100%;
      color: #3b3e51;
      font-size: 1rem;
      font-weight: 400;
      margin: 0;
    }
    .btn-block {
      width: 100%;
      font-size: 1.5rem;
      font-weight: 700;
    }
    span {
      color: #808695;
      font-size: 0.85rem;
    }
    .cash-out-amount {
      position: relative;
      width: 100%;
      input {
        background-color: white;
        border: 1.1px solid #f2f3f4;
        border-radius: 1rem;
        height: 62px;
        padding-left: 4.5rem;
        width: 100%;
      }
      label {
        position: absolute;
        color: #3b3e51;
        font-size: 1rem;
        line-height: 1rem;
        top: 31px;
        margin-top: -0.5rem;
        left: 2rem;
      }
    }
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
    hr {
        margin-bottom: 3rem;
    }
    .transaction-info {
        align-items: flex-start;
        justify-content: space-between;
    }
}
</style>
